import { requireScript } from "./../helpers/require-script";
import Raven from "raven-js";

// @MIGRATION-TODO: Change to appropriate subdomain
const TOKEN_URL = APP_DOMAIN + "/billing/_setup_token/";

let card, clientSecret, stripe;
const initStripe = async (withSetupToken = false) => {
    const promises = [requireScript("https://js.stripe.com/v3/")];

    if (withSetupToken) {
        promises.unshift(fetch(TOKEN_URL, { credentials: "include" }).then((res) => res.text()));
    }

    return Promise.all(promises).then((results) => {
        if (withSetupToken) {
            [clientSecret] = results;
        }

        stripe = Stripe(STRIPE_KEY);
        const elements = stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        const style = {
            base: {
                fontSize: "14px",
                lineHeight: "24px",
                iconColor: "#A7A7A7",
                color: "#41465A",
                fontWeight: 300,
                ":focus": {
                    // Border is not a supported property but I leave it in as a TODO
                    // 'border': '#0FC382',
                    iconColor: "#0FC382",
                },
                "::placeholder": { color: "#A7A7A7" },
                fontFamily: "open-sans,Arial,sans-serif",
            },
        };

        // Create an instance of the card Element
        card = elements.create("card", { style });

        // Add an instance of the card Element into the `card-element` <div>
        card.mount("#stripe-credit-card");

        return card;
    });
};

const handleCardSetup = async (nameOnCard, email) =>
    await stripe.handleCardSetup(clientSecret, card, {
        payment_method_data: {
            billing_details: { name: nameOnCard, email },
        },
    });

const handleCardAction = async (secret) => await stripe.handleCardAction(secret);

const createPaymentMethod = async (nameOnCard) =>
    await stripe.createPaymentMethod("card", card, {
        billing_details: { name: nameOnCard },
    });

export { initStripe, handleCardSetup, handleCardAction, createPaymentMethod };
